<template>
  <v-dialog
    v-model="visible"
    :width="modalWidth"
    :height="modalHeight"
    persistent
    :retain-focus="false"
  >
    <v-card
      style="position: relative; height: 100%; max-height: calc(100vh - 48px)"
    >
      <div class="d-flex justify-space-between align-center">
        <h1 v-if="mode === 'edit'">
          Sub Task zosynchronizovaný z Office365 sa nedá upravovat. Upravte ho
          vo svojom kalendári a pockajte na zosynchronizovanie s Task Managerom
        </h1>
        <h1 v-else-if="mode === 'delete'">
          Sub Task zosynchronizovaný z Office365 sa nedá zmazať. Zmažte ho vo
          svojom kalendári a pockajte na zosynchronizovanie s Task Managerom
        </h1>

        <div class="d-flex align-start">
          <a-reset-size-button @reset="resetModalSize" />
          <a-close-button @close="closeModal()" />
        </div>
      </div>
      <a-resize-handle
        :current-width="modalWidthPx"
        :current-height="modalHeightPx"
        @resize="handleModalResize"
        @resize-end="handleResizeEnd"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import modalMixin from '@/plugins/tm@modal/_mixins/modal.mixin';
import AResizeHandle from '@/plugins/tm@modal/_components/a-resize-handle.vue';
import AResetSizeButton from '@/plugins/tm@modal/_components/a-reset-size-button.vue';
import ACloseButton from '@/plugins/tm@modal/_components/a-close-button.vue';

export default {
  components: {
    AResizeHandle,
    AResetSizeButton,
    ACloseButton,
  },

  mixins: [modalMixin],

  props: {
    mode: {
      type: String,
      default: 'edit', // edit or delete
    },
  },
  emits: ['close', 'on-subtask-edited'],

  data() {
    return {
      visible: false,
      subtask: null,
      modalName: 'z-unable-to-edit-office-task-modal',
      modalSize: 'small',
    };
  },

  methods: {
    async showModal({ subtask }) {
      this.subtask = subtask;
      this.visible = true;
    },

    async complete() {},

    closeModal() {
      this.visible = false;
    },
  },
};
</script>
